const messages = {
  step3: {
    actionBtn: "Bejelentkezés",
  },
};

export default {
  messages,
};
